import {API_MODULES, API_ROUTES, API_SOLUTIONS, ApiRoute} from "@api/ApiRoutes";
import {Issue, Ticket} from "@lib/Contact/ContactModels";
import {getRequest, postRequest} from "@api/ApiService";
import {generateApiEndpoint} from "@api/ApiUtils";

const ROUTES: Record<string, ApiRoute> = {
    GET_ISSUE_LIST: {
        path: API_ROUTES.GET_ISSUE_LIST,
        module: API_MODULES.CONFIGURATION,
        solution: API_SOLUTIONS.MZ
    },
    POST_TICKET: {
        path: API_ROUTES.POST_TICKET,
        module: API_MODULES.SOLUTION_CMR_BACKOFFICE,
        solution: API_SOLUTIONS.MZ
    }
}

class ContactService {
    static getIssueList = async (): Promise<Issue[]> => {
        return await getRequest<Issue[]>(generateApiEndpoint(ROUTES.GET_ISSUE_LIST));
    }

    static postTicket = async (ticket: Ticket): Promise<Ticket|boolean> => {
        return await postRequest<Ticket>(generateApiEndpoint(ROUTES.POST_TICKET), ticket);
    }
}

export default ContactService;